import { useEffect } from "react";

import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";

import type { UserDTO } from "../../common/types/UserDTO";
import toUserContext from "../utils/toUserContext";

export interface FeatureFlagState {
  almanac?: boolean;
  showRexFileUpload?: boolean;
  allowThinkingExpansion?: boolean;
  showEditChart?: boolean;
  manualUploadDatasetDialog?: boolean;
  showForecasts?: boolean;
  showWorkflows?: boolean;
  appMaintenance?: boolean;
}

const useLaunchDarkly = (userData: UserDTO | undefined) => {
  const ldClient = useLDClient();
  const flags = useFlags<FeatureFlagState>();

  useEffect(() => {
    if (!ldClient) return;
    const updateLaunchDarklyContext = async () => {
      await ldClient.identify(toUserContext(userData));
    };

    void updateLaunchDarklyContext();
  }, [ldClient, userData]);

  if (!ldClient) return {};

  return { flags };
};

export default useLaunchDarkly;
